import { InMemoryCache } from '@apollo/client'

function myPagination(keyArgs = []) {
  return {
    keyArgs,
    read(existing, { args, args: { offset, max } }) {
      if (!existing) {
        return
      }
      const results = existing.results ? existing.results.slice(offset, offset + max) : []
      // console.log('read', args, existing.results, results)
      return { ...existing, results }
    },
    merge(existing, incoming, { args, args: { offset } }) {
      const results = existing && existing.results ? existing.results.slice(0) : []
      for (let i = 0; i < incoming.results.length; ++i) {
        results[offset + i] = incoming.results[i]
      }
      // console.log('merge', args, existing?.results, incoming.results, results)
      return { ...incoming, results }
    }
  }
}

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        questionList: myPagination(['filter'])
      }
    },
    Form: {
      fields: {
        beginDate: {
          merge(_, date) {
            return date && date.substring(0, 10)
          }
        },
        endDate: {
          merge(_, date) {
            return date && date.substring(0, 10)
          }
        }
      }
    }
  }
})

export default cache
